import React from 'react';
import { Image, Text, View } from 'react-native';
import WarningModal from '~/credsystem/assets/imgs/warningInvoices.png';

const PendingInvoiceAlert = () => {
  return (
    <View className="flex-1 rounded-md items-center justify-center p-4 min-h-[228px] bg-light-100 shadow-lg">
      <Image source={WarningModal} />
      <Text className="text-base text-center mb-6 ml-6 mr-6 text-dark-600">
        Parece que sua fatura ainda está pendente {':('}
      </Text>
      <Text className="mb-4 text-center text-dark-500">
        Para regularizar a situação, vá até uma de nossas lojas ou entre em
        contato com nossa{' '}
        <Text className="mb-4 text-center text-dark-500 font-bold">
          Central de Atendimento
        </Text>
        através do número :
        <Text className="text-center text-dark-500 font-bold">
          {'\n'}0800 777 9406
        </Text>
      </Text>
    </View>
  );
};

export default PendingInvoiceAlert;
